import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountI } from '@interfaces/finance/general';

export const accountSlice = createSlice({
    name: 'accountData',
    initialState: { accountId: undefined } as AccountI,
    reducers: {
        setAccountData: (state, action: PayloadAction<AccountI>) => {
            state.accountId = action.payload.accountId;
            state.personId = action.payload.personId;
            state.organizationId = action.payload.personId;
            state.accountRole = action.payload.accountRole;
            state.statusCode = action.payload.statusCode;
            state.currencyCode = action.payload.currencyCode;
        },
    },
});

export const { setAccountData } = accountSlice.actions;
export default accountSlice.reducer;
